export default __webpack_public_path__ + "static/media/google-social-logo.221af0d6.svg";